import React from "react";

/**
 * Top page details
 */
interface IMandatoryOptionalProps {
    isMandatory:boolean,
    isVisible:boolean
}
const MandatoryOptional = (props:IMandatoryOptionalProps) => {


    return (
        <>
            {props.isVisible && props.isMandatory &&
                <div className="bg-red font-bold text-white px-2 ml-4 rounded">
                    Mandatory
                </div>
            }
            {props.isVisible && !props.isMandatory &&
                <div className="bg-green font-bold text-white px-2 ml-4 rounded">
                    Optional
                </div>
            }
        </>
    );
};

export default MandatoryOptional;
